// extracted by mini-css-extract-plugin
export default {"title":"styles_title__QejzN","bookingsToRateList":"styles_bookingsToRateList__XHNAT","loading":"styles_loading__Nc9Xk"};